import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Header, CustomButton,  } from "../../components";
import { logAnalyticEvent } from "../../analytics";
import { EVENT_NAME } from "../../constants";
import { convertTimestamp } from "../../utils";
import "./styles.scss";
import { EmailMarketing } from "../../assets/gif";

const RemindMeLaterPopup = ({ visible, handleDone }) => {
  const { t } = useTranslation();
  console.log(visible, "visible");
  const contentRef = useRef(null);

  const [startTime, setStartTime] = useState(0);

  useEffect(() => {
    if (visible && contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
    setStartTime(Date.now());
    return () => {
      const endTime = Date.now();
      logAnalyticEvent(EVENT_NAME.PAGE_VIEW, {
        page_title: `remind_me_later`,
        path: `${window.location.origin}/remind_me_later`,
        end_time: endTime,
        start_time: startTime,
        time_spent: convertTimestamp(endTime - startTime),
      });
    };
  }, [visible]);

  return (
    <div className={`terms-and-privacy-modal ${visible ? "show" : "hide"}`}>
      <div className="terms-and-privacy-modal-content" ref={contentRef}>
        <Header containerStyle={"d-flex justify-content-end w-100"} />
        <img
          src={EmailMarketing}
          alt={"EmailMarketing"}
          className={`custom-image `}
        />
        <h1 className="heading">
          {t("company-details.received_reminder_request_heading")}
        </h1>
        <p className="description">
          {t("company-details.received_reminder_request_description")}
        </p>

        <CustomButton text={t("company-details.done")} onClick={handleDone} />
      </div>
    </div>
  );
};

export default RemindMeLaterPopup;
